import { render } from "./verifyEmailChange.vue?vue&type=template&id=7a0170e6"
import script from "./verifyEmailChange.vue?vue&type=script&lang=js"
export * from "./verifyEmailChange.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__